import { CoreEvent } from '@pbl/digital-games-core/lib/core/CoreEvent';

export class AudioManager {
  private soundEffectsEnabled: boolean = true;
  private musicEnabled: boolean = true;
  private volume: number = 1;

  public readonly soundEffectPlayed: CoreEvent = new CoreEvent();
  public readonly musicPlayed: CoreEvent = new CoreEvent();
  public readonly musicPaused: CoreEvent = new CoreEvent();
  public readonly volumeChanged: CoreEvent = new CoreEvent();

  constructor(soundEffectsEnabled, musicEnabled) {
    this.soundEffectsEnabled = soundEffectsEnabled;
    this.musicEnabled = musicEnabled;
  }

  public isMusicEnabled() {
    return this.musicEnabled;
  }

  public areSoundEffectsEnabled() {
    return this.soundEffectsEnabled;
  }

  public enableMusic() {
    this.musicEnabled = true;
    this.musicPlayed.notify();
  }

  public disableMusic() {
    this.musicEnabled = false;
    this.musicPaused.notify();
  }

  public setVolume(vol) {
    this.volume = vol;
    if (this.musicEnabled && this.volumeChanged) {
      this.volumeChanged.notify();
    }
  }

  public getVolume() {
    return this.volume;
  }
  public getSFXVolume() {
    //sound effects music actual volume should be 60% of full volume for this track
    return 0.6 * this.volume;
  }
  public getBGVolume() {
    //background music actual volume should be 20% of full volume for this track
    return 0.4 * this.volume;
  }

  public toggleMusic() {
    if (this.musicEnabled) {
      this.disableMusic();
    } else {
      this.enableMusic();
    }
  }

  public playMusic() {
    if (this.musicEnabled) {
      this.musicPlayed.notify();
    }
  }

  public enableSoundEffects() {
    this.soundEffectsEnabled = true;
  }

  public disableSoundEffects() {
    this.soundEffectsEnabled = false;
  }

  public toggleSoundEffects() {
    if (this.soundEffectsEnabled) {
      this.disableSoundEffects();
    } else {
      this.enableSoundEffects();
    }
  }

  public playSoundEffect(name) {
    if (this.areSoundEffectsEnabled()) {
      this.soundEffectPlayed.notify(name);
    }
  }
}
